import SubmissionError from '../../../error/SubmissionError'
import http from '../../../utils/http'
import security from '../../../utils/security'
import {
  INVOICE_CREATE_ERROR,
  INVOICE_CREATE_LOADING,
  INVOICE_CREATE_SUCCESS,
  INVOICE_CREATE_VIOLATIONS,
  INVOICE_CREATE_RESET,
} from './mutation-types'

const state = {
  loading: false,
  error: '',
  created: null,
  violations: {},
}

function error (error) {
  return {type: INVOICE_CREATE_ERROR, error}
}

function loading (loading) {
  return {type: INVOICE_CREATE_LOADING, loading}
}

function success (created) {
  return {type: INVOICE_CREATE_SUCCESS, created}
}

function violations (violations) {
  return {type: INVOICE_CREATE_VIOLATIONS, violations}
}

function reset () {
  return {type: INVOICE_CREATE_RESET}
}

const getters = {
  created: state => state.created,
  error: state => state.error,
  loading: state => state.loading,
  violations: state => state.violations,
}

const actions = {
  create ({commit}, values) {
    commit(loading(true))
    commit(violations({}))
    commit(error(null))
    if(typeof values.amount == 'string'){
      values.amount = values.amount.replace(',','.').replace(' ','');
    }
    for(let i = 0; i < values.items.length; i++){
      if(typeof values.items[i].amount == 'string'){
        values.items[i].amount = values.items[i].amount.replace(',','.').replace(' ','');
      }
      if(typeof values.items[i].price == 'string'){
        values.items[i].price = values.items[i].price.replace(',','.').replace(' ','');
      }
      if(values.items[i].amount == null || values.items[i].price == ''){
        values.items[i].amount = 0;
      }
      if(values.items[i].price == null || values.items[i].price == ''){
        values.items[i].price = 0;
      }
      values.items[i].amount = parseFloat(values.items[i].amount);
      values.items[i].price = parseFloat(values.items[i].price);
    }
    if(values.correctedInvoice && values.correctedInvoice['@id']){
      values.correctedInvoice = values.correctedInvoice['@id']
    }
    values.amount = parseFloat(values.amount);
    return http.fetch('/invoices', {method: 'POST', body: JSON.stringify(values)})
      .then(response => {
        commit(loading(false))

        return response.json()
      })
      .then(data => {
        commit(success(data))
        commit(updateAgreementData(data.agreement), {root: true})
      })
      .catch(e => {
        commit(loading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors))
          commit(error(e.errors._error))
          return
        }

        commit(error(e.message))
      })
  },
  reset ({commit}) {
    commit(reset())
  }
}

const mutations = {
  [INVOICE_CREATE_ERROR] (state, payload) {
    state.error = payload.error
  },
  [INVOICE_CREATE_LOADING] (state, payload) {
    state.loading = payload.loading
  },
  [INVOICE_CREATE_SUCCESS] (state, payload) {
    state.created = payload.created
  },
  [INVOICE_CREATE_VIOLATIONS] (state, payload) {
    state.violations = payload.violations
  },
  [INVOICE_CREATE_RESET] (state) {
    state.loading = false
    state.error = ''
    state.created = null
    state.violations = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/create.js